import Services from "../../../services";

class UnitProduksiApi {
  page(params) {
    return Services.get("/hrda/unit_produksi/page", { params });
  }

  single(params) {
    return Services.get("/hrda/unit_produksi/single", { params });
  }

  create(value) {
    return Services.post("/hrda/unit_produksi", value);
  }

  update(value) {
    return Services.put("/hrda/unit_produksi", value);
  }

  delete(value) {
    return Services.post("/hrda/unit_produksi/delete", value);
  }
}

export default new UnitProduksiApi();
